//auth 2.0
import Plugin from "./plugin";
import "./styles/index.css";

export default Plugin;
